import { gql } from '@apollo/client';

export const LIST_CLIENT_BILL_EXPORT_TEMPLATE_CONFIGS = gql`
    query ListClientBillExportTemplateConfigs(
        $settlementClientId: ID
        $billType: BillTypeEnum
        $pageRequest: PageRequestInput!
    ) {
        listClientBillExportTemplateConfigs(
            settlementClientId: $settlementClientId
            billType: $billType
            pageRequest: $pageRequest
        ) {
            content {
                id
                settlementClientId
                clientName
                billType
                exportTemplate
                updatedAt
            }
            page
            size
            totalElements
            totalPages
        }
    }
`;

export const UPSERT_CLIENT_BILL_EXPORT_TEMPLATE_CONFIG = gql`
    mutation UpsertClientBillExportTemplateConfig(
        $settlementClientId: ID!
        $billType: BillTypeEnum!
        $exportTemplate: BillExportTemplateType!
    ) {
        upsertClientBillExportTemplateConfig(
            settlementClientId: $settlementClientId
            billType: $billType
            exportTemplate: $exportTemplate
        ) {
            id
            settlementClientId
            clientName
            billType
            exportTemplate
            updatedAt
        }
    }
`;

export const DELETE_CLIENT_BILL_EXPORT_TEMPLATE_CONFIG = gql`
    mutation DeleteClientBillExportTemplateConfig($id: ID!) {
        deleteClientBillExportTemplateConfig(id: $id)
    }
`;
